/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Week_BodyInputs */

const en_portal_week_body = /** @type {(inputs: Portal_Week_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sessions with your coach, plan days and meals in one calendar. On iPhone, Android and the web.`)
};

const pl_portal_week_body = /** @type {(inputs: Portal_Week_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Treningi z trenerem, dni z planu i posiłki w jednym kalendarzu. Na iPhone’a, Androida i w przeglądarce.`)
};

/**
* | output |
* | --- |
* | "Sessions with your coach, plan days and meals in one calendar. On iPhone, Android and the web." |
*
* @param {Portal_Week_BodyInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const portal_week_body = /** @type {((inputs?: Portal_Week_BodyInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Week_BodyInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_portal_week_body(inputs)
	return en_portal_week_body(inputs)
});